import { render, staticRenderFns } from "./FiBuOPGuthaben.vue?vue&type=template&id=398f4d5e&scoped=true&"
import script from "./FiBuOPGuthaben.vue?vue&type=script&lang=js&"
export * from "./FiBuOPGuthaben.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f4d5e",
  null
  
)

export default component.exports